import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import autobind from 'autobind-decorator'

class TInputForm extends Component {

	constructor(props) {
		super(props);

		this.inputElm = React.createRef()
		const focus = props.focus;
		this.state = {
      focus: !!(focus),
		};
	}

	componentDidMount() {
		const { focus } = this.props;
		const input = this.inputElm.current
		if (focus) {
			input.focus();
			const temp = input.value;
			input.value = '';
			input.value = temp
		}
	}

	@autobind
	handleChange(e) {
		const { onChange } = this.props;

		if (onChange) {
			onChange(e.target.value)
		}
	}

	@autobind
	handleFocus() {
		const { onFocus } = this.props;
		if (onFocus) {
			onFocus()
		}
		this.setState({
			focus: true
		})
	}

	@autobind
	handleBlur() {
		const { onBlur } = this.props;
		if (onBlur) {
			onBlur()
		}
		this.setState({
			focus: false
		})
	}

	focus() {
		this.inputElm.current.focus()
	}

	abortEnter(e) {
    const keyCode = e.keyCode;
    if(keyCode === 13){
      e.preventDefault();
    }
	};

	render() {
		const { type, id, className, disabled, placeholder, tabIndex, title, maxlength, min, max, value} = this.props;
		const { focus } = this.state;

		return (
			<input ref={this.inputElm} type={type} id={id} className={classnames(className, { "tf_on": focus })} value={value}
				   disabled={disabled} placeholder={placeholder} tabIndex={tabIndex} title={title} maxLength={maxlength}
				   min={min} max={max}
				   onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur} onKeyDown={this.abortEnter}/>
		)
	}
}

TInputForm.propTypes = {
	type: PropTypes.string,
	id: PropTypes.string,
	className: PropTypes.string,
	value: PropTypes.any.isRequired,
	placeholder: PropTypes.string,
	tabIndex: PropTypes.any,
	focus: PropTypes.bool,
	maxlength: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default TInputForm
